<template>
  <b-modal ref="updateSpreadsheetModal" hide-footer centered>
    <b-form @submit.prevent="updateSpreadsheet" novalidate>
      <div v-if="!excelDataProvided">
        <b-form-group
          label="Excel form data:"
          >
          <b-form-input
            type="text"
            autocomplete="off"
            placeholder="Paste excel form data here..."
            @paste.native="parseClipboard($event)"
            />
        </b-form-group>
        <b-form-file v-model="excelFile" placeholder="Choose a file..."></b-form-file>
        <br>
        <br>
      </div>
      <b-alert
        variant="success"
        dismissible
        :show="excelDataProvided"
        @dismissed="resetExcelData"
        >
        Excel data provided.
      </b-alert>
      <b-button type="submit" :disabled="inProgress">Update</b-button>
    </b-form>
  </b-modal>
</template>

<script>
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

let $ = window.$

export default {
  props: ['sheet'],
  data () {
    return {
      excelData: '',
      excelFile: null,
      inProgress: false,
      excelDataProvided: false
    }
  },
  watch: {
    excelFile () {
      if (!this.excelFile) return
      this.$readExcelFile(this.excelFile, (result) => {
        this.excelDataProvided = true
        this.excelData = result
      })
    }
  },
  methods: {
    updateSpreadsheet () {
      if (!this.$count(this.excelData)) return
      this.$refs.updateSpreadsheetModal.hide()

      this.$store.commit('addProcess', {
        process: 'importSheetData',
        message: 'Importing data'
      })

      db.sheets.update(this.sheet, this.excelData, () => {
        this.resetExcelData()
      })
    },
    parseClipboard (e) {
      this.$excelFromClipboard(e, (result) => {
        this.excelData = result
        this.excelDataProvided = true
      })
    },
    resetExcelData () {
      this.excelData = false
      this.excelFile = null
      this.excelDataProvided = false
      this.$store.commit('deleteProcess', 'importSheetData')
    }
  },
  created () {
    eventBus.$on('updateSpreadsheet', () => {
      if (this.$refs.updateSpreadsheetModal) this.$refs.updateSpreadsheetModal.show()
    })
  },
  mounted () {
    if (this.$refs.updateSpreadsheetModal) {
      $(this.$refs.updateSpreadsheetModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.updateSpreadsheetModal) {
      $(this.$refs.updateSpreadsheetModal['$el']).remove()
    }
  }
}
</script>
